import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminImpersonateUser = () => {
  return apiClient.admin.impersonateUser.useMutation({
    onError: (error: any) => {
      showErrorToast(error, 'Error impersonating user!');
    },
  });
};
